import { createBrowserClient } from '@supabase/ssr'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://placeholder.supabase.co'
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || 'placeholder-key'

// Only create client if we have real environment variables
export const supabase = supabaseUrl !== 'https://placeholder.supabase.co' 
  ? createBrowserClient(supabaseUrl, supabaseAnonKey)
  : null

// Edge function URLs
const FUNCTIONS_URL = `${supabaseUrl}/functions/v1`

export const apiEndpoints = supabase ? {
  projects: `${FUNCTIONS_URL}/projects`,
  pressKit: `${FUNCTIONS_URL}/press-kit`,
  careers: `${FUNCTIONS_URL}/careers`,
  blog: `${FUNCTIONS_URL}/blog`,
} : {
  projects: '/api/mock/projects',
  pressKit: '/api/mock/press-kit', 
  careers: '/api/mock/careers',
  blog: '/api/mock/blog',
}
